import { useSelector } from 'react-redux';
import { RootState } from '../store';

export function useDefinitionsLoaded(): boolean {
  return useSelector((state: RootState) => state.model.parameters.length > 0);
}
